import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

export const importFileTypesExecErknm: (keyof typeof UploadFileTypesEnum)[] = [];
